export default "__VITE_ASSET__VmU0CtVI__"